var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('at-ta',{staticClass:"colors-autocomplete",attrs:{"ats":['#'],"members":_vm.colors,"filterMatch":_vm.filterMatch},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item)+" ")]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }